type ForgetPasswordState = 'emailInput' | 'emailSent'

interface StateTransitions {
  [key: string]: ForgetPasswordState[]
}

export const useForgetPasswordStateMachine = () => {
  const currentState = ref<ForgetPasswordState>('emailInput')
  
  const transitions: StateTransitions = {
    emailInput: ['emailSent'],
    emailSent: ['emailInput']
  }
  
  const isValidTransition = (from: ForgetPasswordState, to: ForgetPasswordState): boolean => {
    return transitions[from]?.includes(to) ?? false
  }
  
  const transition = (newState: ForgetPasswordState): boolean => {
    if (isValidTransition(currentState.value, newState)) {
      currentState.value = newState
      return true
    }
    console.warn(`Invalid transition from ${currentState.value} to ${newState}`)
    return false
  }
  
  const isState = (state: ForgetPasswordState): boolean => {
    return currentState.value === state
  }
  
  const reset = () => {
    currentState.value = 'emailInput'
  }
  
  return {
    currentState: readonly(currentState),
    transition,
    isState,
    reset,
    isValidTransition
  }
}